// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page .tag{border:1px solid var(--color-lightGrey);color:var(--color-grey);display:inline-block;letter-spacing:.5px;line-height:1;padding:.5rem;text-transform:uppercase}.page .tag.is-small{font-size:.75em;padding:.4rem}.page .tag.is-large{font-size:1.125em;padding:.7rem}.page .tag+.tag{margin-left:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
